var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LazyHydrate',{attrs:{"never":""}},[_c('div',{staticClass:"script-container",domProps:{"innerHTML":_vm._s(_vm.scriptContent)}})])}
var staticRenderFns = []

export { render, staticRenderFns }